import { Component, OnInit } from '@angular/core';
import { Source } from '../../models/source';
import { SelectItems } from '../../../../shared/Models/SelectItems';
import { SourceMasterService } from '../../services/source.master.service';
import { Router } from '@angular/router';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { CreateDataSourceComponent } from '../create/create.component';

@Component({
  selector: 'app-update-source',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss'],
})
export class UpdateSourceComponent implements OnInit {
  sourceId: number;
  source: Source = {} as Source;
  activityTypesOptions: SelectItems[];

  constructor(
    private service: SourceMasterService,
    private router: Router,
    private diag: NbDialogRef<UpdateSourceComponent>,
    private toast: NbToastrService,
  ) {}

  ngOnInit() {
    this.service.getById(this.sourceId).subscribe((res) => {
      this.source = res;
    });
  }
  save() {
    this.service.put(this.sourceId, this.source).subscribe((res) => {
      this.toast.success('Update source successfully', 'success', { duration: 4000 });
      this.diag.close('true');
    });
  }
}
